export const GET_CLIENTS_REQUEST = "GET_CLIENTS_REQUEST";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";

export const GET_CLIENTS_DROPDOWN_REQUEST = "GET_CLIENTS_DROPDOWN_REQUEST";
export const GET_CLIENTS_DROPDOWN_SUCCESS = "GET_CLIENTS_DROPDOWN_SUCCESS";
export const GET_CLIENTS_DROPDOWN_FAILURE = "GET_CLIENTS_DROPDOWN_FAILURE";


export const GET_CLIENTS_CREATE_REQUEST = "GET_CLIENTS_CREATE_REQUEST";
export const GET_CLIENTS_CREATE_SUCCESS = "GET_CLIENTS_CREATE_SUCCESS";
export const GET_CLIENTS_CREATE_FAILURE = "GET_CLIENTS_CREATE_FAILURE";


export const GET_ORG_REQUEST = "GET_ORG_REQUEST";
export const GET_ORG_SUCCESS = "GET_ORG_SUCCESS";
export const GET_ORG_FAILURE = "GET_ORG_FAILURE";